import * as React from 'react';
export const arrowUpRightSvg = React.forwardRef(function arrowUpRightSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4.5.563a.75.75 0 0 0 0 1.5h4.377L1.345 9.595a.75.75 0 1 0 1.06 1.06l7.533-7.532V7.5a.75.75 0 0 0 1.5 0V1.312a.75.75 0 0 0-.75-.75H4.5Z',
    }),
  );
});
arrowUpRightSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var arrowUpRight = {
  category: 'icon',
  colorable: true,
  name: 'arrowUpRight',
  svg: arrowUpRightSvg,
};
